import './style.scss';

type SeverityPillsProps = {
  severity: number;
  totalPills?: number;
  overrideColorMap?: { [key: number]: string };
};
const severityColorMap: { [key: number]: string } = {
  1: '#F5F5F5',
  2: '#FFA111',
  3: '#FF8080',
  4: '#E43030',
};
const severityColorMap2: { [key: number]: string } = {
  1: '#F5F5F5',
  2: '#FFA111',
  3: '#ff8080',
  4: '#df5b5b',
  5: '#E43030',
};
export const SeverityPills = ({
  severity,
  totalPills = 4,
  overrideColorMap,
}: SeverityPillsProps) => {
  const baseArray = Array(totalPills).fill('#444444');
  const defaultColorMap = totalPills === 4 ? severityColorMap : severityColorMap2;
  const colorMap = overrideColorMap ?? defaultColorMap;

  return (
    <div className="pill-set" data-testid={`severity-pills-${severity}`}>
      {baseArray.map((defaultColor, index) => {
        return (
          <div
            key={index}
            className="pill-single"
            style={{
              backgroundColor: index < severity ? colorMap[severity] : defaultColor,
            }}
          />
        );
      })}
    </div>
  );
};
